// extracted by mini-css-extract-plugin
export var dropdownIcon = "_q1-6";
export var imgContainer = "_q1-3";
export var menuIcon = "_q1-5";
export var pillWrapper = "_q1-2";
export var pillsContainer = "_q1-1";
export var subscriptionCard = "_q1-0";
export var subscriptionLogo = "_q1-4";